<div
  class="d-flex justify-content-between commodity-offer-breakdown-cell"
  [ngClass]="backgroundClass"
>
  <div>
    {{ description }}
  </div>
  <div>{{ prefix }} {{ value | roundedCurrency }}</div>
</div>
